import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
interface CreatorLabProgramProps {
  onApplyClick: () => void;
}
const details = ['4-week program', '5 creators per cohort', '4–6 Pulse Markets', 'Fully remote', 'Weekly cohort call', 'Optional 1:1 support'];
export function CreatorLabProgram({
  onApplyClick
}: CreatorLabProgramProps) {
  return <section id="program" className="py-28 lg:py-40 bg-navy-950 relative overflow-hidden" data-id="element-45">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-mint-500/[0.04] rounded-full blur-[100px] -z-10" data-id="element-46" />

      <div className="max-w-3xl mx-auto px-6" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-48">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-mint-500/10 to-wave-500/10 border border-mint-500/20 mb-8" data-id="element-49">
            <span className="relative flex h-2 w-2" data-id="element-50">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-mint-400 opacity-75" data-id="element-51"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-mint-500" data-id="element-52"></span>
            </span>
            <span className="text-sm font-semibold text-mint-400" data-id="element-53">
              Limited to 5 creators
            </span>
          </div>

          <h2 className="text-5xl lg:text-6xl font-extrabold mb-6 text-white" data-id="element-54">
            Creator Lab
          </h2>

          <p className="text-xl text-slate-300 max-w-xl mx-auto leading-relaxed" data-id="element-55">
            Test Pulse Markets live, get
            direct support, leave with a repeatable format.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="rounded-2xl bg-gradient-to-b from-slate-800/40 to-slate-900/20 p-[1px] mb-12" data-id="element-56">
          <div className="rounded-2xl bg-gradient-to-b from-navy-900 to-navy-950 p-8 lg:p-10" data-id="element-57">
            <div className="grid sm:grid-cols-2 gap-x-10 gap-y-5 mb-10" data-id="element-58">
              {details.map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-59">
                  <div className="w-1.5 h-1.5 rounded-full bg-mint-500 flex-shrink-0" data-id="element-60" />
                  <span className="text-slate-200 font-medium" data-id="element-61">{item}</span>
                </div>)}
            </div>

            <div className="pt-8 border-t border-slate-800/40 flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-62">
              <div data-id="element-63">
                <span className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-mint-400 to-wave-400" data-id="element-64">
                  $2,000
                </span>
                <span className="text-slate-400 ml-3 font-medium" data-id="element-65">
                  stipend upon completion
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-center" data-id="element-66">
          <Button variant="primary" onClick={onApplyClick} className="text-lg px-10 py-4 shadow-xl shadow-mint-500/15 hover:shadow-mint-500/25" data-id="element-67">
            Apply to the Creator Lab
          </Button>
        </motion.div>
      </div>
    </section>;
}